export default __webpack_public_path__ + "static/media/phone.e9f9ee2e.png";